var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"system-references"},[_c('MultipleTextAreas',{attrs:{"textAreas":_vm.textAreas,"noContentString":_vm.$t('hasNoReferences'),"disabled":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }